import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("Confirmando tu correo...");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setStatus("error");
      setMessage("Enlace de verificación inválido.");
      return;
    }

    axios
      .get(`${API_URL}/auth/verify-email`, { params: { token } })
      .then((res) => {
        setStatus("success");
        setMessage(res.data?.message || "Correo confirmado correctamente.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(
          err.response?.data?.message ||
            "No fue posible confirmar tu correo.",
        );
      });
  }, [API_URL, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="w-full max-w-md mx-4 p-10 bg-white/90 rounded-3xl shadow-2xl backdrop-blur-md text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Verificación de correo
        </h2>
        <p className="text-gray-600 mb-8">{message}</p>
        {status !== "loading" && (
          <button
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold"
            onClick={() => navigate("/login")}
          >
            Ir a iniciar sesión
          </button>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
